import Vue from 'vue'
import SvgIcon from '@/components/SvgIcon/index.vue' // svg组件

// 注册到全局
Vue.component('svg-icon', SvgIcon)

const requireAll = requireContext => requireContext.keys().map(requireContext)
const req = require.context('./svg', false, /\.svg$/)
console.log("icon图标",req)
requireAll(req)